// src/data/scannedFile.js
//
// Record 591 (ruling 247). Ruling 247: "every sinle file must be scanned for viruses and security issues before
// actually downloading and / utilized in any manner." Since Record 590, storage.rules lets a non-admin read a
// file only after the scanner has marked it clean - so the link can no longer be fetched at upload, when the
// file has not been scanned yet. Uploads now store the file's Storage PATH (the url / downloadURL field stays on
// the record, empty), and the link is fetched HERE, when the user clicks View. A refusal at that moment means
// the scanner has not cleared the file, and the user is told so in plain words.
//
// Used by src/pages/DisciplineCases.js, src/pages/ClaimDocuments.js and src/pages/ClaimDetail.js.
import { ref, getDownloadURL } from 'firebase/storage';

export const STILL_BEING_CHECKED = 'This file is still being checked for viruses. Try again in a minute.';

// Fetch the link for a stored path and open it in a new tab. Throws an Error whose message is fit to show.
export async function openStoredFile(storage, path) {
  if (!path) throw new Error('This file has no stored location on the record, so it cannot be opened.');
  let url;
  try {
    url = await getDownloadURL(ref(storage, path));
  } catch (e) {
    if (e && e.code === 'storage/unauthorized') throw new Error(STILL_BEING_CHECKED);
    throw new Error('This file could not be opened (' + ((e && e.code) || (e && e.message) || 'unknown error') + ').');
  }
  if (typeof window !== 'undefined') window.open(url, '_blank', 'noopener,noreferrer');
  return url;
}

// The onClick of a View link. A record that already carries a link (uploaded before Record 591) opens it as
// before, through the link's own href; a record that carries only its path is resolved now. Never silent.
export function viewStoredFile(storage, url, path) {
  return (e) => {
    if (url) return;
    if (e && e.preventDefault) e.preventDefault();
    openStoredFile(storage, path).catch((err) => window.alert((err && err.message) || String(err)));
  };
}
